// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"30":"4e0f96959c00cb5f754e","280":"e4a211f2e38c5785f78e","298":"be34898c7a525df7aa42"}[chunkId] + ".bundle.js";
};